/** Эквайринг: выплаты реестров CloudPayments (`/api/acquiring-payouts`) и выгрузка из кабинета. */
import { apiFetch, query } from "@/lib/api";
import type { Money } from "@/lib/pnl";

export type Payout = {
  id: number;
  date: string;
  gateway: string;
  count: number;
  amount: Money;
  /** Комиссия вместе с НДС сверху — сколько удержано за эквайринг. */
  fee: Money;
  /** Претензии и прочие удержания. */
  held: Money;
  payout: Money;
  /** СБП и нулевые выплаты: денег от CloudPayments не будет — зачисляет банк. */
  direct: boolean;
  entrepreneur_name: string | null;
  operation_id: number | null;
  operation_date: string | null;
  account_id: number | null;
  account: string | null;
  statement_id: number;
};

export type PayoutPage = {
  total: number;
  sum: {
    count: number;
    amount: Money;
    fee: Money;
    held: Money;
    payout: Money;
    matched_payout: Money;
    unmatched: number;
  };
  rows: Payout[];
};

export type PayoutFilter = {
  entrepreneur_id?: number | undefined;
  date_from?: string | undefined;
  date_to?: string | undefined;
  unmatched?: boolean | undefined;
  limit?: number | undefined;
  offset?: number | undefined;
};

export function loadPayouts(filter: PayoutFilter): Promise<PayoutPage> {
  return apiFetch(`/api/acquiring-payouts${query(filter)}`);
}

export type SyncReport = {
  started: string;
  finished: string | null;
  months: string;
  sites: string[];
  new: number;
  updated: number;
  unchanged: number;
  empty: number;
  failed: string[];
  error: string | null;
};

export type SyncState = { running: boolean; report: SyncReport | null };

export function loadSync(): Promise<SyncState> {
  return apiFetch("/api/acquiring/cloudpayments/sync");
}

export function startSync(since: string | null): Promise<SyncState> {
  return apiFetch("/api/acquiring/cloudpayments/sync", { method: "POST", body: JSON.stringify({ since }) });
}
